import React, { useState, useEffect, useRef } from "react";

const ContextMenu = ({ x, y, items, onClose, visible }) => {
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div
      ref={menuRef}
      className="fixed bg-white border border-gray-200 rounded-lg shadow-lg py-2 z-50 min-w-48"
      style={{
        left: x,
        top: y,
        maxHeight: 'calc(100vh - 20px)',
        overflowY: 'auto'
      }}
    >
      {items.map((item, index) => (
        <div key={index}>
          {item.divider ? (
            <div className="border-t border-gray-200 my-1" />
          ) : (
            <button
              className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center gap-2 ${
                item.disabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700'
              } ${item.danger ? 'hover:bg-red-50 hover:text-red-600' : ''}`}
              onClick={() => {
                if (!item.disabled) {
                  item.onClick();
                  onClose();
                }
              }}
              disabled={item.disabled}
            >
              {item.icon && <span className="text-base">{item.icon}</span>}
              <span className="flex-1">{item.label}</span>
              {item.shortcut && (
                <span className="text-xs text-gray-400 ml-2">{item.shortcut}</span>
              )}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

const useContextMenu = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [items, setItems] = useState([]);

  const showContextMenu = (event, menuItems) => {
    event.preventDefault();
    
    const { clientX, clientY } = event;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const menuWidth = 200; // přibližná šířka menu
    const menuHeight = menuItems.length * 35; // přibližná výška menu
    
    let x = clientX;
    let y = clientY;
    
    // Zajistí, že menu nevyjde z okna
    if (x + menuWidth > windowWidth) {
      x = windowWidth - menuWidth - 10;
    }
    if (y + menuHeight > windowHeight) {
      y = windowHeight - menuHeight - 10;
    }
    
    setPosition({ x, y });
    setItems(menuItems);
    setIsVisible(true);
  };

  const hideContextMenu = () => {
    setIsVisible(false);
    setItems([]);
  };

  return {
    isVisible,
    position,
    items,
    showContextMenu,
    hideContextMenu
  };
};

export { ContextMenu, useContextMenu };
